import React from 'react';
import Button from '../Button/Button';
import FormTextarea from '../FormTextarea/FormTextarea';
import { validateStudentNote } from '../../../utils';
import styles from './StudentNotesComposeForm.module.css';

interface StudentNotesComposeFormProps {
  value: string;
  loading?: boolean;
  readOnly?: boolean;
  fieldId?: string;
  fieldLabel?: string;
  placeholder?: string;
  minRows?: number;
  maxRows?: number;
  skipValidation?: boolean;
  onChange: (value: string) => void;
  onCancel: () => void;
  onSubmit: () => void;
}

const StudentNotesComposeForm: React.FC<StudentNotesComposeFormProps> = ({
  value,
  loading = false,
  readOnly = false,
  fieldId = 'student-notes-modal-new-note',
  fieldLabel = 'Nova observação',
  placeholder = 'Escreva aqui a observação que deseja enviar.',
  minRows = 2,
  maxRows,
  skipValidation = false,
  onChange,
  onCancel,
  onSubmit,
}) => {
  if (readOnly) {
    return null;
  }
  const noteError = !skipValidation && value.trim() ? validateStudentNote(value) : '';
  const canSubmit = !loading && (skipValidation || !validateStudentNote(value));

  return (
    <form
      className={styles.form}
      onSubmit={(event) => {
        event.preventDefault();
        onSubmit();
      }}
    >
      <FormTextarea
        id={fieldId}
        label={fieldLabel}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        rows={minRows}
        minRows={minRows}
        maxRows={maxRows}
        disabled={loading}
        error={noteError || undefined}
      />

      <div className={styles.actions}>
        <Button
          type="button"
          variant="ghost"
          size="small"
          className={styles.actionButton}
          onClick={onCancel}
          disabled={loading}
        >
          Cancelar
        </Button>
        <Button
          type="submit"
          variant="primary"
          size="small"
          className={styles.actionButton}
          disabled={!canSubmit}
        >
          {loading ? 'Aguarde...' : 'Salvar'}
        </Button>
      </div>
    </form>
  );
};

export default StudentNotesComposeForm;
